import {SET_VALIDATED_REQUEST} from "../../../enums/Request/request.types";

export const setValidatedApplicationAction = (data) => {
    return {
        type: SET_VALIDATED_REQUEST,
        payload: data,
    };
};